@if (visible$()) {
  <div class="lab-tooltips-container">
    @for (overlay of overlays$(); track overlay.id) {
      <div
        class="lab-tooltip-overlay"
        [attr.data-tooltip-id]="overlay.id"
        [style.left.px]="overlay.left"
        [style.top.px]="overlay.top"
        [style.transform]="overlay.transform"
      >
        <div
          class="lab-tooltip lab-tooltip-{{ overlay.position }}"
          [class.lab-tooltip-exiting]="overlay.exiting"
          [id]="overlay.id"
          role="tooltip"
        >
          {{ overlay.text | translate }}
        </div>
      </div>
    }
  </div>
}
